import {
   SET_PAGE_NAME,
   SET_PAGE_NAME_SUCCESS
} from './../constants/constants'
import { put, takeLatest } from 'redux-saga/effects'


function* setPageName(action) {    
   yield put({ type: SET_PAGE_NAME_SUCCESS, data: action.payload });
}


function* PageManagement() {
   yield takeLatest(SET_PAGE_NAME, setPageName);

}


export default PageManagement;